//
export const PRO_USER_MAX_VIDEO_SIZE_BYTES = 250000000;
export const PRO_USER_MAX_IMAGE_SIZE_BYTES = 3000000;
export const PRO_USER_MAX_IMAGE_SIZE_STRING = `${Math.floor(
  PRO_USER_MAX_IMAGE_SIZE_BYTES / 1000000
)}MB`;

export const PRO_USER_MAX_VIDEO_SIZE_STRING = `${Math.floor(
  PRO_USER_MAX_VIDEO_SIZE_BYTES / 1000000
)}MB`;
